// Papa Diaries — SHOP dropdown hover-to-swap. Desktop/mouse only —
// mobile uses the drawer menu, not this hover mega-menu, and hover
// has no real meaning on touch anyway.
//
// When a shopper hovers or keyboard-focuses a category link inside
// the header's SHOP mega-menu (Earrings, Necklaces, Bracelets, Rings,
// Sets, All pieces), the featured product cards shown alongside it
// update to preview that category instead of always showing the same
// fixed set.
//
// Defensive by design: if the expected markup or data isn't present
// for any reason, every step bails out quietly. This must never
// throw or block the menu from working normally.
(function () {
  'use strict';

  if (window.matchMedia('(pointer: coarse)').matches) return;

  var dataEl = document.getElementById('pd-mega-menu-data');
  if (!dataEl) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  function handleFromHref(href) {
    var match = href && href.match(/\/collections\/([a-z0-9-]+)/i);
    return match ? match[1] : null;
  }

  function applyProducts(items, products) {
    items.forEach(function (item, i) {
      var product = products[i];
      var card = item.querySelector('.resource-card');
      if (!card) return;

      if (!product) {
        item.style.visibility = 'hidden';
        return;
      }
      item.style.visibility = '';

      var link = card.querySelector('.resource-card__link');
      var img = card.querySelector('.resource-card__image');
      var title = card.querySelector('.resource-card__title');
      var priceEl = card.querySelector('.price');

      if (link) link.setAttribute('href', product.url);
      if (img) {
        img.setAttribute('src', product.image);
        img.setAttribute('srcset', product.image + ' 1x, ' + product.image2x + ' 2x');
      }
      if (title) title.textContent = product.title;
      if (priceEl) priceEl.textContent = product.price;
    });
  }

  var lastHandle = null;

  function handleHover(event) {
    var link = event.target.closest && event.target.closest('.mega-menu__link:not(.mega-menu__link--parent)');
    if (!link) return;

    var submenu = link.closest('.menu-list__submenu');
    if (!submenu) return;

    var handle = handleFromHref(link.getAttribute('href'));
    if (!handle || handle === lastHandle) return;

    var products = data[handle];
    if (!products) return;

    var items = submenu.querySelectorAll('.mega-menu__content-list-item');
    if (!items.length) return;

    lastHandle = handle;
    applyProducts(items, products);
  }

  document.addEventListener('pointerover', handleHover, { passive: true });
  document.addEventListener('focusin', handleHover, true);
})();
